export function getOrderedRuns<T>(
  runsById: Record<string, T | undefined>,
  order?: string[]
): T[] {
  const orderedIds = order?.length ? order : Object.keys(runsById);

  return orderedIds.reduce<T[]>((acc, id) => {
    const run = runsById[id];
    if (run != null) {
      acc.push(run);
    }
    return acc;
  }, []);
}
